<template>
  <div class="footer" :style="{ justifyContent: centered ? 'center' : 'flex-end', gridTemplateColumns: centered ? '1fr' : '6fr 6fr' }">
    <CustomButton
      v-if="!this.hideCancelBtn"
      @click="() => !this.cancelApproveMode && closePopup()"
      :disabled="this.loading || this.cancelLoading || btnLoading"
      :loading="this.cancelLoading"
      no-caps
      outlined
    >
      {{ this.cancelBtnText || 'Отмена' }}
      <PopupConfirm
        v-if="this.cancelApproveMode"
        :title="this.cancelApproveTitle || 'Подтвердите действие'"
        :approve="this.closePopup"
      />
    </CustomButton>
    <CustomButton
      v-if="!this.hideSubmitBtn"
      :disabled="this.loading || btnLoading || !!this.disableSubmit || this.cancelLoading"
      :loading="this.loading || btnLoading"
      type="submit"
      @click="handleSubmit"
      >{{ this.submitBtnText || 'Сохранить' }}</CustomButton
    >
  </div>
</template>

<script>
import { inject } from 'vue'
import PopupConfirm from "@/components/common/PopupConfirm";
import CustomButton from "@/components/common/CustomButton.vue";
import { useAppStore } from "@/services/store/app";

export default {
  name: "CustomModalFooter",
  components: {PopupConfirm, CustomButton},
  props: ["onSubmit", "onCancel", "hideCancelBtn", "cancelBtnText", "hideSubmitBtn", "submitBtnText", "btnLoading", "cancelApproveMode", "cancelApproveTitle", "disableSubmit", "centered"],
  data() {
    return {
      loading: false,
      cancelLoading: false,
    }
  },
  methods: {
    async handleSubmit() {
      if(!this.onSubmit) return
      this.loading = true
      try {
        await this.onSubmit()
      } finally {
        this.loading = false
      }
    },
    async closePopup() {
      if(this.onCancel) {
        this.cancelLoading = true
        try {
          await this.onCancel()
        } finally {
          this.cancelLoading = false
        }
        return
      }
      if(this.secondaryModal.show) {
        this.closeSecondaryModal()
        return
      }
      // const requestDiscard = this.requestModalDiscardClose
      // if (typeof requestDiscard === 'function') {
      //   requestDiscard()
      //   return
      // }
      this.closeModal()
    },
  },
  setup() {
    const { closeModal, secondaryModal, closeSecondaryModal } = useAppStore()
    const requestModalDiscardClose = inject('requestModalDiscardClose', null)
    return { closeModal, requestModalDiscardClose, closeSecondaryModal, secondaryModal }
  }
}
</script>

<style scoped lang="scss">
@use "@/assets/styles/quasar.variables.scss" as *;

.footer {
  width: 100%;
  height: 40px;
  display: grid;
  grid-template-columns: 6fr 6fr;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 15px;

  &__btn {
    font-size: 14px;
    border-radius: 8px;

    &_submit {
      background-color: $primary-light;
      color: #fff;
    }
    &_cancel {
      background-color: #fff;
      color: $primary-light;
      border: 1px solid $primary-light;
      &::before {
        box-shadow: none;
      }
    }
    &_disabled {
      background: #c7c7c7 !important;
    }
  }
}
</style>
